export default function Textarea(props) {
  return (
    <textarea placeholder={props.placeholder} value={props.value} onChange={(event)=>{
      props.onchange(event.target.value)
    }} className={`text-[11px] md:text-[14px] ${props.classes}`}/>
  );
}
